<p>Redirecting to Savvas Realize for configuration setup!</p>
<mat-spinner diameter="60" mode="indeterminate" class="mat-spinner"></mat-spinner>